<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table :headers="headers" :items="Deductions" :search="search" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Deducciones</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Buscar" single-line
              hide-details>
            </v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="40%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="success" dark class="mb-2" v-bind="attrs" @click="clearDeduction" v-on="on">
                  Nueva deduccion
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="newDeduction.description_long" label="Nombre"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="newDeduction.description_short" label="Nombre corto"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field v-model="newDeduction.priority" label="Prioridad" type="number"
                          inset></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-switch v-model="deductionClass" label="Legal" inset></v-switch>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-switch v-model="deduction_status" @click="disableNotification" label="Activo" inset></v-switch>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-autocomplete dense item-value="id" item-text="name"
                          v-model="newDeduction.debit_chart_of_account_id" :items="accounts" color="cyanText"
                          label="Cuenta debito" outlined required></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-autocomplete dense item-value="id" item-text="name"
                          v-model="newDeduction.credit_chart_of_account_id" :items="accounts" color="cyanText"
                          label="Cuenta credito" outlined required></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" text @click="save"> Guardar </v-btn>
                  <v-btn color="red darken-1" text @click="close"> Cancelar </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon large color="accent" class="mr-2" @click="editItem(item)">
            edit
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize"> Reset </v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "Codigo",
          align: "start",
          value: "id",
        },
        { text: "Descripcion", value: "description_long" },
        { text: "Descripcion corta", value: "description_short" },
        { text: "Prioridad", value: "priority" },
        { text: "Tipo", value: "class_description" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      search: "",
      accounts: [],
      Deductions: [],
      newDeduction: [],
      deduction_status: true,
      deductionClass: false,
      itemsCities: [],
      itemsPaymentTypes: [],
      editedIndex: -1,
      editedItem: {
        description: "",
      },
      defaultItem: {
        descripcion: "",
      },
    };
  },
  components: {
    // Barra
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva deduccion" : "Editar deduccion";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.getData();
      let resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      let accounts=await resultTypeAccounts.json();
      accounts.forEach(element => {
        element.name=element.name+" (" +element.code+")"
        this.accounts.push({
          name: element.code+" - "+ element.name,
          id: element.id,
        
        })
      });
      //combo payment Types---------------------------------------------
      this.itemsPaymentTypes = await this.g_ComboGeneric("humanResource/paymentTypes");
    },
    async getData() {
      const result = await this.api_Get("humanResource/deductions");
      const data = await result.json();
      this.Accruals_const = data;
      for (var key in this.Accruals_const) {
        this.Deductions.push({
          id: this.Accruals_const[key].id,
          description_long: this.Accruals_const[key].description_long,
          description_short: this.Accruals_const[key].description_short,
          priority: this.Accruals_const[key].priority,
          debit_chart_of_account_id: this.Accruals_const[key].debit_chart_of_account_id,
          credit_chart_of_account_id: this.Accruals_const[key].credit_chart_of_account_id,
          deduction_class_id:
            this.Accruals_const[key].deduction_class_id === 1 ? true : false,
          class_description: this.Accruals_const[key].class_description,
          status_id: this.Accruals_const[key].status_id,
        });
      }
    },
    editItem(item) {
      this.editedIndex = this.Deductions.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.newDeduction = this.Deductions[this.editedIndex];
      this.newDeduction.contact_type = 3;
      this.deductionClass = this.newDeduction.deduction_class_id;
      this.newDeduction.status_id === 1
        ? (this.deduction_status = true)
        : (this.deduction_status = false);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      // var datos = this.editedItem;
      let estatus = 1;
      this.deduction_status === false ? (estatus = 3) : (estatus = 1);
      let datos = {
        id: this.newDeduction.id,
        description_long: this.newDeduction.description_long.trim(),
        description_short: this.newDeduction.description_short.trim(),
        debit_chart_of_account_id: this.newDeduction.debit_chart_of_account_id,
        credit_chart_of_account_id: this.newDeduction.credit_chart_of_account_id,
        priority: this.newDeduction.priority,
        class_var: this.deductionClass === true ? 1 : 2,
        status_id: estatus,
      };

      if (this.editedIndex > -1) {
        //Modificar
        const result = await this.api_Put("humanResource/deductions", datos);
        if (result.status == 200) {
          this.Deductions.splice(0, this.Deductions.length);
          this.getData();
          this.$toast.success("Guardado")
        } else {
          this.$toast.error(" error");
        }
      } else {
        //Crear nuevo
        const result = await this.api_Post("humanResource/deductions", datos);
        if (result.status == 200) {
          this.Deductions.splice(0, this.Deductions.length);
          this.successNotification("Registrado con exito!");
          this.dialog = false;
          this.getData();
        } else {
          this.errorNotification("Ha ocurrido un error!");
        }
      }

      this.close();
    },
    clearDeduction() {
      this.newDeduction = {
        id: "",
        description_long: "",
        description_short: "",
        priority: "",
        class: false,
        status_id: 1,
      };
      this.deduction_status = true;
    },
    disableNotification() {
      if (this.deduction_status == false) {
        this.warningNotification("Se desactivara esta deduccion!");
      }
    },
  },
};
</script>
